import { render, staticRenderFns } from "./tagDialog.vue?vue&type=template&id=54911ee2"
import script from "./tagDialog.vue?vue&type=script&lang=js"
export * from "./tagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports